/**
 * Side-effect module: installs the translation layer at import time.
 *
 * This exists because ES imports are hoisted. Calling `installTranslation()`
 * as a statement in index.tsx would run it *after* every imported module had
 * already been evaluated, so any component holding JSX at module scope
 * (`const icon = <Icon />`) would have been built from untranslated elements
 * and would stay English for the life of the session.
 *
 * Import this first, before anything that pulls in React components.
 */
import { installTranslation } from './translate';
import { getLanguage } from '.';
import moment from 'moment';
import 'moment/locale/fr';

installTranslation();

// Dates render through moment all over the application. Without this the
// interface would read French while every date read "Monday 3 September".
moment.locale(getLanguage());
